var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatroomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chatroom_icon",
    transform: "translate(20261 14232)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176057",
    "data-name": "Rectangle 176057",
    width: 28,
    height: 28,
    transform: "translate(-20261 -14232)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chat-room_1_",
    "data-name": "chat-room (1)",
    transform: "translate(-20270.242 -14241.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1526089",
    "data-name": "Path 1526089",
    d: "M11.106,36.488H35.382a1.1,1.1,0,0,0,1.088-1.294l-1.9-8.824V11.747A1.757,1.757,0,0,0,32.808,10H13.68a1.757,1.757,0,0,0-1.762,1.747V26.369l-1.9,8.847a1.091,1.091,0,0,0,.247.882,1.107,1.107,0,0,0,.845.389Zm24.617-.82a.445.445,0,0,1-.342.158H11.106a.446.446,0,0,1-.34-.156.419.419,0,0,1-.1-.331l.554-2.575h24.05l.55,2.555a.424.424,0,0,1-.1.35ZM11.9,29.6H16.88l-.324,2.5H11.362Zm.618-2.869h4.736l-.286,2.207H12.042Zm21.454,0,.475,2.207H29.522l-.286-2.207ZM17.224,32.1l.324-2.5h5.365v2.5Zm6.351-2.5H28.94l.324,2.5H23.575Zm6.357,2.5-.324-2.5h4.981l.538,2.5Zm-1.364-5.366.286,2.207H23.575V26.735Zm-5.655,2.207H17.634l.286-2.207h4.993ZM13.68,10.662H32.808a1.094,1.094,0,0,1,1.1,1.085V26.073H12.581V11.747a1.094,1.094,0,0,1,1.1-1.085Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526090",
    "data-name": "Path 1526090",
    d: "M36.675,27.987h.182v1.619a.331.331,0,0,0,.531.264l2.487-1.883h1.384a3.173,3.173,0,0,0,3.169-3.169V21.561a3.173,3.173,0,0,0-3.169-3.169H36.675a3.173,3.173,0,0,0-3.169,3.169v3.256a3.173,3.173,0,0,0,3.169,3.169Zm-2.507-6.426a2.51,2.51,0,0,1,2.507-2.507h4.584a2.51,2.51,0,0,1,2.507,2.507v3.256a2.51,2.51,0,0,1-2.507,2.507h-1.5a.332.332,0,0,0-.2.067L37.519,28.94V27.656a.331.331,0,0,0-.331-.331h-.513a2.51,2.51,0,0,1-2.507-2.507Z",
    transform: "translate(-15.723 -5.613)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatroomIcon);
export default __webpack_public_path__ + "static/media/chatroom_icon.356bd95f5a2fc237f7ed14c004a16880.svg";
export { ForwardRef as ReactComponent };